import React, { useState } from "react";
import { registrationIconUrls } from "../registrationAssets";

/**
 * Renders a Figma-exported icon when present; falls back to inline SVG.
 */
export const RegistrationIcon = ({ name, className, fallback: Fallback }) => {
  const [failed, setFailed] = useState(false);
  const src = registrationIconUrls[name];

  if (!failed && src) {
    return (
      <img
        src={src}
        alt=""
        className={className}
        onError={() => setFailed(true)}
      />
    );
  }

  return Fallback ? <Fallback /> : null;
};
